import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { Grid, Typography } from "@material-ui/core";
import { ContactInformation, ErrorPageContent } from "@ploy-ui/core";
import { ContactInfoResource, ApplicationSignerResource, CustomerType, SignerType } from "@ploy-lib/rest-resources/";
import { useAppLoad } from "../../appLoadContext";
import { FormattedMessage } from "react-intl";
import { useVariableData } from "@ploy-lib/calculation";
import { useInvalidator, useResource } from "@rest-hooks/core";
import { ErrorHandler } from "@ploy-lib/core";
import { useFormikContext } from "formik";
import { SigningDocumentResource, useResourceWithInvalidate } from "@ploy-lib/rest-resources";
import { CustomerRole } from "@ploy-lib/types";
addRegisteredSectionLayout({
    name: "UpdateContactInfoSection",
    displayName: "UpdateContactInfoSection",
    settings: {
        editableOptions: { showUpdateSupplier: true, showUpdateCoSigner: true }
    }
});
addRegisteredSectionLayout({
    name: "UpdateSupplierContactPersonInfoSection",
    displayName: "UpdateSupplierContactPersonInfoSection",
    settings: {}
});
const UpdateContactInfoSectionInternal = memo((props) => {
    const { className, showUpdateSupplier = false, onClick, showUpdateCoSigner = false, showUpdateCustomer = true, options } = props;
    const { applicationNumber } = useAppLoad();
    const contactInfo = useResource(ContactInfoResource.detailAll(), applicationNumber ? { applicationNumber } : null) ?? {};
    const { [CustomerRole.Customer]: customer, [CustomerRole.CoSigner]: cosigner, [CustomerRole.Supplier]: supplier } = contactInfo;
    const { value: showUpdateSupplierForCustomer } = useVariableData("Customer", "HideUpdateSupplier");
    const formik = useFormikContext();
    const invalidateSigners = useInvalidator(ApplicationSignerResource.list());
    const onSuccess = useCallback((info) => {
        if (info.type === CustomerType.Private &&
            info.role === CustomerRole.Customer)
            invalidateSigners({
                signerType: 0,
                applicationNumber
            });
        formik.setFieldValue(`${info.role}.PhoneHome`, info.phoneHome);
        formik.setFieldValue(`${info.role}.PhoneMobile`, info.phoneMobile);
        formik.setFieldValue(`${info.role}.Email`, info.email);
        formik.setFieldValue(`${info.role}.ContactPerson`, info.contactPerson);
        formik.setFieldValue(`${info.role}.ContactPersonEmail`, info.contactPersonEmail);
    }, [invalidateSigners, applicationNumber, formik]);
    return (_jsxs(Grid, { container: true, spacing: 2, className: className, onClick: onClick, children: [applicationNumber &&
                showUpdateSupplier &&
                showUpdateSupplierForCustomer &&
                supplier ? (_jsxs(_Fragment, { children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { variant: "h6", paragraph: true, children: _jsx(FormattedMessage, { id: "dealer.change.contact.information.header.supplier", description: "Contact information header supplier", defaultMessage: "Supplier" }) }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(ContactInformation, { contactInfo: supplier, onUpdateContactInfo: onSuccess, applicationNumber: applicationNumber, ...options?.supplier }) })] })) : null, applicationNumber && showUpdateCustomer && customer ? (_jsxs(_Fragment, { children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { variant: "h6", paragraph: true, children: _jsx(FormattedMessage, { id: "dealer.change.contact.information.header.customer", description: "Contact information header", defaultMessage: "Customer" }) }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(ContactInformation, { contactInfo: customer, onUpdateContactInfo: onSuccess, applicationNumber: applicationNumber, ...options?.customer }) })] })) : null, applicationNumber &&
                cosigner &&
                cosigner.type !== CustomerType.NotSet &&
                showUpdateCoSigner ? (_jsxs(_Fragment, { children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { variant: "h6", paragraph: true, children: _jsx(FormattedMessage, { id: "dealer.change.contact.information.header.coSigner", description: "Contact information header", defaultMessage: "Meds\u00F8ker" }) }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(ContactInformation, { contactInfo: cosigner, onUpdateContactInfo: onSuccess, applicationNumber: applicationNumber, ...options?.cosigner }) })] })) : (_jsx(_Fragment, {}))] }));
});
const UpdateContactInfoSection = (props) => (_jsx(ErrorHandler, { fallback: e => (_jsx(ErrorPageContent, { className: props.className, onClick: props.onClick, header: _jsxs("span", { children: [UpdateContactInfoSection.displayName, " failed to render."] }) })), children: _jsx(UpdateContactInfoSectionInternal, { ...props }) }));
UpdateContactInfoSection.displayName = "DployUpdateContactInfoSection";
const emptyArray = [];
const UpdateSupplierContactPersonInfoSection = (props) => {
    const { applicationNumber } = useAppLoad();
    const documents = useResourceWithInvalidate(SigningDocumentResource.list(), applicationNumber
        ? {
            applicationNumber
        }
        : null) ?? emptyArray;
    const supplierVendorDocumentsAreSigned = documents
        .filter(document => document.signerTypes.includes(SignerType.VendorSigner))
        .every(document => document.signed);
    return (_jsx(ErrorHandler, { fallback: e => (_jsx(ErrorPageContent, { className: props.className, onClick: props.onClick, header: _jsxs("span", { children: [UpdateSupplierContactPersonInfoSection.displayName, " failed to render."] }) })), children: _jsx(UpdateContactInfoSectionInternal, { ...props, showUpdateCustomer: false, showUpdateSupplier: true, options: {
                supplier: {
                    disabled: supplierVendorDocumentsAreSigned,
                    showCustomerInfo: false
                }
            } }) }));
};
UpdateSupplierContactPersonInfoSection.displayName =
    "DployUpdateSupplierContactPersonInfoSection";
export { UpdateContactInfoSection, UpdateSupplierContactPersonInfoSection };
//# sourceMappingURL=UpdateContactInfoSection.js.map